import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { UsersService } from '../../services/users-resolver.service';
import { ChangeAvatarService } from '@core/components/change-avatar/change-avatar.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { MessageService } from '@core/errors/messages-service';
import { UploadService } from '@core/services/upload.service';
import { getErrorCode } from '@core/utils/get-error-code';
import { DialogArchiveOrUnarchiveUserComponent } from '../dialog-archive-or-unarchive-user/dialog-archive-or-unarchive-user.component';
import { TabGeneralComponent } from './tabs/general/tab-general.component';
import { takeUntil } from 'rxjs/operators';
import english from '../../i18n/en.json';
import spanish from '../../i18n/es.json';
import portuguese from '../../i18n/pt.json';
var DialogUsersComponent = /** @class */ (function () {
    function DialogUsersComponent(dialogData, fuseTranslationLoaderService, matDialogRef, customMessageService, changeAvatarService, fuseProgressBarService, imageUploadService, messageService, usersService, materialDialog, fb) {
        this.dialogData = dialogData;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.matDialogRef = matDialogRef;
        this.customMessageService = customMessageService;
        this.changeAvatarService = changeAvatarService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.imageUploadService = imageUploadService;
        this.messageService = messageService;
        this.usersService = usersService;
        this.materialDialog = materialDialog;
        this.fb = fb;
        this.selectedTabIndex = 0;
        this.isLoading = false;
        this.unsubscribeAll = new Subject();
        this.reloadPage = new Subject();
        this.user = this.dialogData.user;
        this.isViewMode = this.dialogData.isViewMode;
        this.currentUser = this.dialogData.currentUser;
        this.reloadPage = this.dialogData.reloadPage;
        this.isOnEditDialog = !!(this.user.id);
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DialogUsersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userForm = this.fb.group({
            name: [this.user.name, [Validators.required]],
            type: [this.user.type, [Validators.required]],
            role: [this.user.role, [Validators.required]],
            loginIntegrationEnabled: [this.user.loginIntegrationEnabled || false, [Validators.required]],
            loginProvider: [this.user.loginProvider || 'email-password', [Validators.required]],
            email: [{ value: this.user.email, disabled: !!this.user.id }, [Validators.required, Validators.email]],
            groups: new FormArray((this.user.groups || []).map(function (group) { return _this.fb.group(group); })),
            preferences: this.fb.group({
                featureOpenedMaintenanceSendEmailNotification: new FormControl(this.user.preferences ? this.user.preferences.featureOpenedMaintenanceSendEmailNotification : false)
            })
        });
        var groupsFormArray = this.userForm.get('groups');
        if (groupsFormArray.value.length) {
            this.hasLinkedGroups = true;
        }
        groupsFormArray.valueChanges.pipe(takeUntil(this.unsubscribeAll)).subscribe(function (value) {
            if (value.length) {
                _this.hasLinkedGroups = true;
            }
            else {
                _this.hasLinkedGroups = false;
            }
        });
        if (this.isViewMode) {
            this.userForm.disable();
        }
    };
    DialogUsersComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    };
    DialogUsersComponent.prototype.openArchiveOrUnarchiveUserDialog = function (archive) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.materialDialog
                            .open(DialogArchiveOrUnarchiveUserComponent, {
                            panelClass: 'dialog-archive-or-unarchive-user',
                            data: {
                                userId: this.user.id,
                                isArchived: archive,
                                isLoading: this.isLoading
                            }
                        }).afterClosed().subscribe(function (value) {
                            if (value && value.reload) {
                                _this.reloadPage.next();
                                _this.matDialogRef.close({ reload: true });
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogUsersComponent.prototype.continue = function () {
        this.selectedTabIndex = 1;
    };
    DialogUsersComponent.prototype.saveUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, savedUser, err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        this.isLoading = true;
                        this.matDialogRef.disableClose = true;
                        input = this.userForm.value;
                        input.groups = this.userForm.get('groups').value.map(function (group) { return group.id; });
                        input.loginIntegrationEnabled = ['active-directory', 'google'].includes(input.loginProvider);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, this.usersService.save(this.user.id, input).toPromise()];
                    case 2:
                        savedUser = _a.sent();
                        if (!!this.isOnEditDialog) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.saveNewUser(savedUser)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.customMessageService.success('USERS.SUCCESS_MESSAGE');
                        this.matDialogRef.close({ reload: true });
                        this.reloadPage.next();
                        return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        code = getErrorCode(err_1);
                        if (code === 'user_email_duplicated') {
                            this.selectedTabIndex = 0;
                            this.userForm.get('email').setErrors({
                                'user_email_duplicated': true
                            });
                            return [2 /*return*/];
                        }
                        if (code === 'login_via_integration_not_configured') {
                            this.selectedTabIndex = 0;
                            this.userForm.get('loginIntegrationEnabled').setErrors({
                                'login_via_integration_not_configured': true
                            });
                            this.customMessageService.error('USERS.INTEGRATION_NOT_CONFIGURED');
                            return [2 /*return*/];
                        }
                        this.messageService.error(err_1);
                        this.customMessageService.error('USERS.ERROR_MESSAGE');
                        return [3 /*break*/, 7];
                    case 6:
                        this.matDialogRef.disableClose = false;
                        this.fuseProgressBarService.hide();
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    DialogUsersComponent.prototype.saveNewUser = function (savedUser) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var avatarImage, avatarUrl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        avatarImage = this.tabGeneralComponent.avatarImagePayload;
                        if (!avatarImage) return [3 /*break*/, 3];
                        this.tabGeneralComponent.avatarImagePayload.path = "users/" + savedUser.id;
                        return [4 /*yield*/, this.imageUploadService.upload(this.tabGeneralComponent.avatarImagePayload)];
                    case 1:
                        avatarUrl = (_a.sent()).path;
                        return [4 /*yield*/, this.changeAvatarService.updateUser({
                                id: savedUser.id,
                                input: { avatarUrl: avatarUrl }
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!this.user['password']) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.usersService.setUserPassword(savedUser.id, {
                                password: this.user['password'],
                                permanentPassword: false
                            }).toPromise()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return DialogUsersComponent;
}());
export { DialogUsersComponent };
